import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ReporteCoordinadorAdministrativoDispatcher,
  reporteCoordinadorAdministrativoDispatcher
} from "./ReporteCoordinadorAdministrativo.dispatcher";
import {
  ReporteCoordinadorAdministrativoStore,
  reporteCoordinadorAdministrativoStore
} from "./ReporteCoordinadorAdministrativo.store";
import ReporteCoordinadorAdministrativoComponent from "../../../components/comisionesCoordinadorAdministrativo/reporte";

interface Props
  extends ReporteCoordinadorAdministrativoStore,
    ReporteCoordinadorAdministrativoDispatcher {}

@ReduxConnect(
  reporteCoordinadorAdministrativoStore,
  reporteCoordinadorAdministrativoDispatcher
)
export default class ReporteCoordinadorAdministrativoContainer extends Component<
  Props
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Reporte de Comisiones - Coordinador Administrativo" />
          <ReporteCoordinadorAdministrativoComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
